import { SvgIconName } from '@aw/shared/components/icon';
import { NotificationType } from '@aw/shared/constants';

export const snackBarIcon: Record<NotificationType, SvgIconName> = {
  success: 'check-circle',
  info: 'info',
  error: 'exclamation-circle',
  warning: 'warning',
};
